const hub = {
  quickStats: "Быстрая статистика",
  totalEntities: "Всего сущностей",
  docsThisWeek: "Документы за неделю",
  openTasks: "Открытые задачи",
  aiConversations: "AI-разговоры сегодня",
  recentActivity: "Последняя активность",
  noActivity: "Нет недавней активности",
  biCharts: "Графики",
  statusDistribution: "Распределение статусов",
  activityTimeline: "Хронология активности",
  entityBreakdown: "Разбивка по сущностям",
  last7Days: "Последние 7 дней",
  last30Days: "Последние 30 дней",
  quickAccess: "Быстрый доступ",
  openItem: "Открыть",
  openInSidePanel: "Открыть в боковой панели",
  duplicate: "Дублировать",
  deleteItem: "Удалить",
  addToFavorites: "В избранное",
  removeFromFavorites: "Из избранного",
  copyLink: "Копировать ссылку",
  editIcon: "Редактировать иконку",
  colorRule: "Правило цвета",
  colorRuleTitle: "Правило цвета",
  colorRuleField: "Поле",
  colorRuleValue: "Значение",
  colorRuleColor: "Цвет",
  colorRuleSave: "Сохранить",
  colorRuleRemove: "Удалить правило",
  linkCopied: "Ссылка скопирована",
} as const;
export default hub;
